/*
 * Frame Position — Leo & Milo
 *
 * Aufgaben:
 *
 * 1. Rahmen-Chooser zwischen Personalisierung und Vorschau-Button verschieben.
 *
 * 2. Kaufzeile bauen:
 *    Quantity + Add-to-Cart nebeneinander.
 *
 * 3. Echte Teeinblue-Personalisierung erkennen:
 *    Sobald der Kunde tatsächlich eine Datei auswählt,
 *    wird dem Shopify-Produktformular automatisch
 *
 *    properties[_lm_personalized] = true
 *
 *    hinzugefügt.
 *
 *    Dadurch kann variant-added.liquid unterscheiden:
 *
 *    personalisiert
 *      -> Teeinblue _customization_image
 *
 *    nicht personalisiert
 *      -> Shopify Variantenbild
 *
 * 4. Mobile Cart Notification:
 *    Impact Drawer öffnet auf Mobile von rechts.
 *
 * Desktop:
 *    open-from="bottom"
 *
 * Mobile:
 *    open-from="right"
 *
 * Es werden weiterhin keine Teeinblue-Knoten verschoben.
 *
 * Selbstheilend bei:
 * - product:rerender
 * - Teeinblue Re-Injection
 * - DOM Änderungen
 */
(function () {
  'use strict';


  /* ============================================================
     KONSTANTEN
  ============================================================ */

  const MOBILE_MEDIA =
    window.matchMedia('(max-width: 749px)');


  const PERSONALIZED_PROPERTY_NAME =
    'properties[_lm_personalized]';


  /*
   * Formulare, an denen bereits ein
   * product:rerender Listener hängt.
   */
  const boundForms =
    new WeakSet();



  /* ============================================================
     SHOPIFY PRODUKTFORMULAR FINDEN
  ============================================================ */

  function getProductForm() {

    /*
     * Hauptweg:
     * Das Formular innerhalb der Buy Buttons.
     */

    let form =
      document.querySelector(
        '.product-info__buy-buttons form'
      );


    if (form) {
      return form;
    }


    /*
     * Fallback:
     * Shopify Produktformular.
     */

    form =
      document.querySelector(
        'form[action*="/cart/add"]'
      );


    return form || null;

  }



  /* ============================================================
     PERSONALISIERUNGS-FLAG
  ============================================================ */

  function getPersonalizedInput(form) {

    if (!form) {
      return null;
    }

    return form.querySelector(
      'input[name="' +
      PERSONALIZED_PROPERTY_NAME +
      '"]'
    );

  }


  function ensurePersonalizedInput(
    form,
    value
  ) {

    if (!form) {
      return null;
    }

    let input =
      getPersonalizedInput(form);

    if (!input) {

      input =
        document.createElement(
          'input'
        );

      input.type =
        'hidden';

      input.name =
        PERSONALIZED_PROPERTY_NAME;

      form.appendChild(
        input
      );

    }

    input.value =
      value
        ? 'true'
        : 'false';

    return input;

  }


  function getRelevantForms() {

    const forms =
      [];

    const productForm =
      getProductForm();

    const teeForm =
      document.querySelector(
        '#tee-artwork-form'
      );

    if (productForm) {

      forms.push(
        productForm
      );

    }

    if (
      teeForm &&
      teeForm !== productForm
    ) {

      forms.push(
        teeForm
      );

    }

    return forms;

  }


  function setPersonalizedFlag(value) {

    const normalizedValue =
      !!value;

    const forms =
      getRelevantForms();

    if (!forms.length) {
      return;
    }

    forms.forEach(
      function (form) {

        ensurePersonalizedInput(
          form,
          normalizedValue
        );

        form.dataset.lmPersonalized =
          normalizedValue
            ? 'true'
            : 'false';

      }
    );

    /*
     * Teeinblue ersetzt teilweise DOM/Formulare.
     * Deshalb Zustand zusätzlich global merken.
     */

    document.documentElement.dataset.lmPersonalized =
      normalizedValue
        ? 'true'
        : 'false';

  }


  function getRememberedPersonalizedFlag() {

    if (
      document.documentElement.dataset
        .lmPersonalized ===
      'true'
    ) {
      return true;
    }

    if (
      document.documentElement.dataset
        .lmPersonalized ===
      'false'
    ) {
      return false;
    }

    const forms =
      getRelevantForms();

    for (
      let i = 0;
      i < forms.length;
      i++
    ) {

      if (
        forms[i].dataset
          .lmPersonalized ===
        'true'
      ) {
        return true;
      }

    }

    return false;

  }


  function restorePersonalizedFlag() {

    const value =
      getRememberedPersonalizedFlag();

    const forms =
      getRelevantForms();

    if (!forms.length) {
      return;
    }

    forms.forEach(
      function (form) {

        ensurePersonalizedInput(
          form,
          value
        );

        form.dataset.lmPersonalized =
          value
            ? 'true'
            : 'false';

      }
    );

    document.documentElement.dataset.lmPersonalized =
      value
        ? 'true'
        : 'false';

  }


  function initializePersonalizedFlag() {

    /*
     * Standard ist IMMER false.
     *
     * Wichtig:
     * Teeinblue erzeugt auch ohne echten Upload
     * eine _customization_image.
     *
     * Deshalb muss Shopify ausdrücklich
     * _lm_personalized=false bekommen.
     */

    if (
      document.documentElement.dataset
        .lmPersonalized !==
      'true'
    ) {

      document.documentElement.dataset.lmPersonalized =
        'false';

    }

    restorePersonalizedFlag();

  }



  /* ============================================================
     ECHTEN DATEI-UPLOAD ERKENNEN
  ============================================================ */

  function fileInputHasFile(input) {

    if (!input) {
      return false;
    }


    if (
      input.type !==
      'file'
    ) {
      return false;
    }


    return !!(
      input.files &&
      input.files.length > 0
    );

  }



  function handleFileInputChange(event) {

    const target =
      event.target;


    if (!target) {
      return;
    }


    if (
      target.tagName !==
      'INPUT'
    ) {
      return;
    }


    if (
      target.type !==
      'file'
    ) {
      return;
    }



    /*
     * Wichtig:
     *
     * Nur Uploads aus dem Bereich des
     * Teeinblue Konfigurators interessieren uns.
     */

    const insideTeeinblue =
      target.closest(
        '#tee-artwork-form'
      ) ||
      target.closest(
        '[class*="tee-"]'
      ) ||
      target.closest(
        '[id*="tee-"]'
      );


    if (!insideTeeinblue) {
      return;
    }



    /*
     * Kunde hat wirklich mindestens
     * eine Datei gewählt.
     */

    if (
      fileInputHasFile(target)
    ) {

      setPersonalizedFlag(
        true
      );

    }

  }



  /*
   * Delegierter Listener.
   *
   * Wichtig bei Teeinblue:
   * Die Upload-Felder werden dynamisch erzeugt.
   * Deshalb nicht direkt an ein einzelnes Input binden.
   */

  document.addEventListener(
    'change',
    handleFileInputChange,
    true
  );



  /* ============================================================
     ZUSÄTZLICHE UPLOAD-ABSICHERUNG
  ============================================================ */

  function scanForSelectedFiles() {

    const teeForm =
      document.querySelector(
        '#tee-artwork-form'
      );


    if (!teeForm) {
      return false;
    }


    const fileInputs =
      teeForm.querySelectorAll(
        'input[type="file"]'
      );


    for (
      let i = 0;
      i < fileInputs.length;
      i++
    ) {

      if (
        fileInputHasFile(
          fileInputs[i]
        )
      ) {

        setPersonalizedFlag(
          true
        );


        return true;

      }

    }


    return false;

  }



  /* ============================================================
     VOR ADD TO CART FLAG ABSICHERN
  ============================================================ */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;


      if (
        !form ||
        form.tagName !==
        'FORM'
      ) {
        return;
      }


      /*
       * Nur Produkt / Cart Add Forms.
       */

      const isProductForm =
        form.matches(
          '.product-info__buy-buttons form'
        ) ||
        (
          form.action &&
          form.action.indexOf(
            '/cart/add'
          ) !== -1
        );


      if (!isProductForm) {
        return;
      }



      /*
       * Falls aktuell noch ein File Input
       * mit Datei existiert:
       * sofort markieren.
       */

      scanForSelectedFiles();



      /*
       * Direkt vor Add-to-Cart das Flag auf beiden
       * relevanten Formularen synchronisieren.
       *
       * Ergebnis:
       * - echter Upload  => _lm_personalized=true
       * - kein Upload    => _lm_personalized=false
       */

      restorePersonalizedFlag();

    },
    true
  );



  /* ============================================================
     PRODUCT:RERENDER
  ============================================================ */

  function bindRerenderListener() {

    const form =
      getProductForm();


    if (
      !form ||
      boundForms.has(form)
    ) {
      return;
    }


    form.addEventListener(
      'product:rerender',
      apply
    );


    boundForms.add(
      form
    );

  }



  /* ============================================================
     FRAME CHOOSER VERSCHIEBEN
  ============================================================ */

  function moveChooser() {

    const chooser =
      document.querySelector(
        'frame-chooser[data-move-into-form]'
      );


    if (!chooser) {
      return;
    }


    const footer =
      document.querySelector(
        '#tee-artwork-form .tee-campaign-form-footer'
      );


    if (!footer) {
      return;
    }


    const blockItem =
      chooser.closest(
        '.product-info__block-item'
      ) ||
      chooser;


    if (
      footer.previousElementSibling ===
      blockItem
    ) {
      return;
    }


    footer.insertAdjacentElement(
      'beforebegin',
      blockItem
    );

  }



  /* ============================================================
     QUANTITY + ADD TO CART
  ============================================================ */

  function buildBuyRow() {

    const buyButtons =
      document.querySelector(
        '.product-info__buy-buttons buy-buttons'
      );


    const quantityInner =
      document.querySelector(
        '.product-info__quantity-selector'
      );



    /*
     * Kompletten Quantity Block verschieben.
     */

    const quantity =
      quantityInner
              ? (
            quantityInner.closest(
              '.product-info__block-item[data-block-type="quantity-selector"]'
            ) ||
            quantityInner
          )
        : null;



    if (
      !buyButtons ||
      !quantity
    ) {
      return;
    }



    let row =
      buyButtons.closest(
        '.frame-buy-row'
      );



    /*
     * Kaufzeile erstellen.
     */

    if (!row) {

      row =
        document.createElement(
          'div'
        );


      row.className =
        'frame-buy-row';


      buyButtons.insertAdjacentElement(
        'beforebegin',
        row
      );

    }



    /*
     * Quantity verschieben.
     */

    if (
      quantity.parentElement !==
      row
    ) {

      row.appendChild(
        quantity
      );

    }



    /*
     * Buy Buttons verschieben.
     */

    if (
      buyButtons.parentElement !==
      row
    ) {

      row.appendChild(
        buyButtons
      );

    }



    /* ==========================================================
       KAUFZEILE LAYOUT
    ========================================================== */

    row.style.display =
      'flex';


    row.style.alignItems =
      'stretch';


    row.style.gap =
      '12px';


    row.style.width =
      '100%';


    row.style.maxWidth =
      '100%';


    row.style.minWidth =
      '0';



    /*
     * Quantity darf nicht wachsen.
     */

    quantity.style.flex =
      '0 0 auto';


    quantity.style.width =
      'auto';


    quantity.style.minWidth =
      '0';



    /*
     * Buy Buttons füllen Restbreite.
     */

    buyButtons.style.display =
      'flex';


    buyButtons.style.flex =
      '1 1 0';


    buyButtons.style.width =
      '100%';


    buyButtons.style.maxWidth =
      'none';


    buyButtons.style.minWidth =
      '0';



    /*
     * Tatsächlicher Add-to-Cart Button.
     */

    const addToCartButton =
      buyButtons.querySelector(
        'button[type="submit"], .button'
      );


    if (addToCartButton) {

      addToCartButton.style.width =
        '100%';


      addToCartButton.style.maxWidth =
        'none';


      addToCartButton.style.flex =
        '1 1 auto';

    }



    /*
     * Eventuell vorhandene Wrapper ebenfalls
     * auf volle Breite.
     */

    Array.from(
      buyButtons.children
    ).forEach(
      function (child) {

        if (
          child.classList.contains(
            'shopify-payment-button'
          ) ||
          child.tagName ===
            'STYLE'
        ) {
          return;
        }


        child.style.width =
          '100%';


        child.style.maxWidth =
          'none';

      }
    );

  }



  /* ============================================================
     MOBILE CART DRAWER
  ============================================================ */

  function updateCartDrawerDirection() {

    const drawer =
      document.querySelector(
        'cart-notification-drawer.quick-buy-drawer'
      ) ||
      document.querySelector(
        'cart-notification-drawer'
      );


    if (!drawer) {
      return;
    }



    /*
     * MOBILE:
     * rechts hinein.
     */

    if (
      MOBILE_MEDIA.matches
    ) {

      if (
        drawer.getAttribute(
          'open-from'
        ) !==
        'right'
      ) {

        drawer.setAttribute(
          'open-from',
          'right'
        );

      }


      return;

    }



    /*
     * DESKTOP:
     * bisheriges Verhalten.
     */

    if (
      drawer.getAttribute(
        'open-from'
      ) !==
      'bottom'
    ) {

      drawer.setAttribute(
        'open-from',
        'bottom'
      );

    }

  }



  /* ============================================================
     MEDIA QUERY CHANGE
  ============================================================ */

  function handleMediaChange() {

    updateCartDrawerDirection();

  }



  if (
    typeof MOBILE_MEDIA.addEventListener ===
    'function'
  ) {

    MOBILE_MEDIA.addEventListener(
      'change',
      handleMediaChange
    );

  }

  else if (
    typeof MOBILE_MEDIA.addListener ===
    'function'
  ) {

    /*
     * Safari Fallback.
     */

    MOBILE_MEDIA.addListener(
      handleMediaChange
    );

  }



  /* ============================================================
     DRAWER DOM OBSERVER
  ============================================================ */

  const drawerObserver =
    new MutationObserver(
      function () {

        updateCartDrawerDirection();

      }
    );


  drawerObserver.observe(
    document.documentElement,
    {
      childList:
        true,

      subtree:
        true
    }
  );



  /* ============================================================
     APPLY
  ============================================================ */

  function apply() {

    bindRerenderListener();

    moveChooser();

    buildBuyRow();

    initializePersonalizedFlag();

    updateCartDrawerDirection();

  }



  /* ============================================================
     TEEINBLUE INJECTED
  ============================================================ */

  document.addEventListener(
    'teeinblue-event-component-injected',
    function () {

      apply();

      /*
       * Teeinblue kann nach dem Event noch
       * weitere DOM-Knoten nachladen.
       */

      setTimeout(
        apply,
        100
      );


      setTimeout(
        apply,
        500
      );

    }
  );



  /* ============================================================
     DOM READY
  ============================================================ */

  if (
    document.readyState !==
    'loading'
  ) {

    apply();

  }

  else {

    document.addEventListener(
      'DOMContentLoaded',
      apply
    );

  }



  /* ============================================================
     FALLBACK / SELBSTHEILUNG
  ============================================================ */

  setInterval(
    function () {

      /*
       * Falls während der Konfiguration noch
       * eine Datei im Upload-Feld liegt.
       */

      scanForSelectedFiles();


      apply();

    },
    1000
  );

})();